import { BrandPods } from '@/components/brand-art';
import { cn } from '@/shared/lib/cn';

type FirstRunHeroProps = { step: 1 | 2 | 3; isFree: boolean };

const STEPS = [1, 2, 3] as const;

export function FirstRunHero({ step, isFree }: FirstRunHeroProps) {
  return (
    <section
      data-enter=""
      data-on-field=""
      className="relative flex flex-wrap items-end justify-between gap-5 overflow-hidden rounded-hero bg-field p-8 text-field-ink"
    >
      <BrandPods variant="first-run" className="-top-10 -right-2.5 h-37.5 w-87.5" />
      <div className="relative flex max-w-160 flex-col gap-3">
        <h1 className="font-semibold text-hero">Give your agents a Mac.</h1>
        <p className="text-lead">
          Three steps, about five minutes.
          {isFree ? ' Your free plan includes 3 Pod-hours, no card needed.' : null}
        </p>
      </div>
      <div className="relative flex flex-col items-end gap-2">
        <span className="font-semibold tabular-nums">Step {step} of 3</span>
        <div aria-hidden="true" className="flex gap-1.5">
          {STEPS.map((number) => (
            <span
              key={number}
              className={cn(
                'h-1.5 w-10 rounded-full',
                number <= step ? 'bg-field-ink' : 'bg-field-faint',
              )}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
